import type { GM_DataFeature, GM_DataStyleOptions } from "../map.type";
import type { MapGeojsonOptions } from "./map-geojson.type";

import {
  MAP_GEOJSON_DEFAULT_FILL_COLOR,
  MAP_GEOJSON_DEFAULT_FILL_OPACITY,
  MAP_GEOJSON_DEFAULT_STROKE_COLOR,
  MAP_GEOJSON_DEFAULT_STROKE_OPACITY,
  MAP_GEOJSON_DEFAULT_STROKE_WEIGHT,
} from "./map-geojson.constant";

export const getMapGeojsonFeatureStyle = (
  feature: GM_DataFeature,
  options?: MapGeojsonOptions
): GM_DataStyleOptions => {
  return {
    fillColor: getStringProperty(
      feature.getProperty("fill"),
      MAP_GEOJSON_DEFAULT_FILL_COLOR
    ),
    fillOpacity: options?.hideArea
      ? 0
      : getNumberProperty(
          feature.getProperty("fill-opacity"),
          MAP_GEOJSON_DEFAULT_FILL_OPACITY
        ),
    strokeColor: getStringProperty(
      feature.getProperty("stroke"),
      MAP_GEOJSON_DEFAULT_STROKE_COLOR
    ),
    strokeOpacity: options?.hidePerimeters
      ? 0
      : getNumberProperty(
          feature.getProperty("stroke-opacity"),
          MAP_GEOJSON_DEFAULT_STROKE_OPACITY
        ),
    strokeWeight: getNumberProperty(
      feature.getProperty("stroke-width"),
      MAP_GEOJSON_DEFAULT_STROKE_WEIGHT
    ),
    clickable: false,
  };
};

const getStringProperty = (value: unknown, defaultValue: string) => {
  const safeValue = typeof value === "string" ? value : undefined;
  return safeValue ?? defaultValue;
};

const getNumberProperty = (value: unknown, defaultValue: number) => {
  const safeValue = typeof value === "number" ? value : undefined;
  return safeValue ?? defaultValue;
};
